import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { FlatLocationOverviewData } from "../../LocationOverview.types";

function getUpdatedColumn(): MRT_ColumnDef<FlatLocationOverviewData> {
  return {
    accessorKey: "updated",
    header: "Änderungsdatum",
    size: 165,
    enableGrouping: false,
    Cell: ({ row }) => row.original.location.updated
  };
}

export { getUpdatedColumn };
